export default __webpack_public_path__ + "static/media/partner_logo_08.bd09ecd0.png";